
export const STORAGE_KEY = 'DISABLE_DEMO_DATA';

export const isDemoDataDisabled = (): boolean => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
};

export const setDemoDataDisabled = (disabled: boolean): void => {
    localStorage.setItem(STORAGE_KEY, String(disabled));
};
